import '.bk{flex-shrink:0;}.ssr-plugin'
import '.bl{width:20rem;}.ssr-plugin'
import '.a8{border:var(--border-subtle);}.ssr-plugin'
import '.bc{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.ah{border-radius:1.25rem;}.ssr-plugin'
import '.bm{padding:1rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.c{gap:2rem;}.ssr-plugin'
import '.bn{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="bk bl a8 bc ah bm"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="d c bn"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
